/* ══════════════════════════════════════════════════════════════════════════
   LG 3D FARO — modelo 3D y «Ver en tu espacio» servidos desde el CDN de FARO
   Marcado: snippets/lg-3d-faro.liquid · Estilos: lg-pdp.css (.lg-3d*)

   El plan de Shopify no admite más de 250 vídeos/modelos 3D, así que los .glb de
   FARO se cargan desde su CDN (CORS abierto; FARO da permiso) con <model-viewer>:
   - Ventiladores: FARO los exporta AL REVÉS (placa abajo): se giran 180° sobre X.
   - Para la RA, el ventilador se cuelga a 2,5 m sobre un aro en el suelo (ningún
     visor ancla al techo). Mismo cálculo que glb_orientacion.ts / glb_techo.ts
     de LUZGURUOPERATIONS.
   - El .usdz del iPhone lo genera model-viewer al vuelo (quick-look).
   - Colocación (data-colocacion, snippets/lg-colocacion.liquid):
     · «pared» (apliques): ar-placement="wall" y el modelo se gira para que su
       anclaje quede atrás (-Z), que es lo que model-viewer pega a la pared. FARO
       exporta los apliques con la pared en Z=0 (bien) o en X=0 (hay que girar
       90° sobre Y). model-viewer 4.0.0 genera el .usdz siempre con anclaje
       horizontal: aquí se cambia a "vertical" para que Quick Look lo pegue a la pared.
     · «techo» (plafones, colgantes, focos…): se endereza (FARO los exporta
       colgando de Y=0, «de pared» en Z o apoyados al revés) y, para la RA, se
       cuelga a 2,5 m sobre el aro, igual que el ventilador.
     · «suelo»: sin cambios.
   - Al cambiar de variante se carga el .glb de su acabado (luzguru3d.faro_glb).
   - «Pruébalo en tu techo» ([data-lg-techo]): carga al pulsar assets/lg-techo.js
     y .css, que reutilizan cargarModelViewer/blobDe de aquí (LgFaro3d).
   Solo se reescribe el bloque JSON del .glb y se añade al final del binario: la
   geometría (Draco incluida) y las texturas no se tocan.
   ══════════════════════════════════════════════════════════════════════════ */
(function (raiz) {
  'use strict';

  var MODEL_VIEWER_URL = 'https://unpkg.com/@google/model-viewer@4.0.0/dist/model-viewer.min.js';
  var ALTURA_TECHO_M = 2.5;
  var HUECO_MINIMO_M = 1.5;
  var ALTURA_MARCA_M = 0.002;
  var SEGMENTOS = 64;
  var GIRO_180_X = [1, 0, 0, 0, 0, -1, 0, 0, 0, 0, -1, 0, 0, 0, 0, 1];
  var GIRO_90_X = [1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1]; // +Z → -Y (cara hacia abajo)
  var GIRO_90_Y = [0, 0, -1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1]; // +X → -Z (atrás)
  var GIRO_MENOS_90_Y = [0, 0, 1, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 0, 1]; // -X → -Z
  var GIRO_180_Y = [-1, 0, 0, 0, 0, 1, 0, 0, 0, 0, -1, 0, 0, 0, 0, 1]; // +Z → -Z
  var HUECO_LAMPARA_M = 0.3; // una lámpara colgada no puede bajar de aquí (un colgante largo, sí de 1,5 m)
  var IDENTIDAD = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
  var GLTF = 0x46546c67, JSON_CHUNK = 0x4e4f534a, BIN_CHUNK = 0x004e4942;

  // ─────────────── .glb: leer, medir, girar, colgar (puro, sin DOM) ───────────────

  function multiplicar(a, b) {
    var r = new Array(16).fill(0);
    for (var c = 0; c < 4; c++) for (var f = 0; f < 4; f++) for (var k = 0; k < 4; k++) r[c * 4 + f] += a[k * 4 + f] * b[c * 4 + k];
    return r;
  }

  function matrizDeNodo(n) {
    if (n && Array.isArray(n.matrix) && n.matrix.length === 16) return n.matrix;
    var t = (n && n.translation) || [0, 0, 0], s = (n && n.scale) || [1, 1, 1], q = (n && n.rotation) || [0, 0, 0, 1];
    var x = q[0], y = q[1], z = q[2], w = q[3];
    return [
      (1 - 2 * (y * y + z * z)) * s[0], 2 * (x * y + z * w) * s[0], 2 * (x * z - y * w) * s[0], 0,
      2 * (x * y - z * w) * s[1], (1 - 2 * (x * x + z * z)) * s[1], 2 * (y * z + x * w) * s[1], 0,
      2 * (x * z + y * w) * s[2], 2 * (y * z - x * w) * s[2], (1 - 2 * (x * x + y * y)) * s[2], 0,
      t[0], t[1], t[2], 1
    ];
  }

  function aplicar(m, p) {
    return [
      m[0] * p[0] + m[4] * p[1] + m[8] * p[2] + m[12],
      m[1] * p[0] + m[5] * p[1] + m[9] * p[2] + m[13],
      m[2] * p[0] + m[6] * p[1] + m[10] * p[2] + m[14]
    ];
  }

  /**
   * Caja en el mundo de cada malla, a partir del min/max de POSITION: min/max (X, Y, Z), y además yMin, yMax y
   * radio horizontal (lo que usa el ventilador).
   */
  function cajasDeMallas(gltf) {
    var cajas = [];
    function visitar(i, padre, prof) {
      var n = gltf.nodes && gltf.nodes[i];
      if (!n || prof > 64) return;
      var m = multiplicar(padre, matrizDeNodo(n));
      if (Number.isInteger(n.mesh)) {
        var min = [Infinity, Infinity, Infinity], max = [-Infinity, -Infinity, -Infinity], radio = 0;
        var prims = (gltf.meshes && gltf.meshes[n.mesh] && gltf.meshes[n.mesh].primitives) || [];
        prims.forEach(function (p) {
          var a = gltf.accessors && p && p.attributes && gltf.accessors[p.attributes.POSITION];
          if (!a || !Array.isArray(a.min) || !Array.isArray(a.max)) return;
          [a.min[0], a.max[0]].forEach(function (x) {
            [a.min[1], a.max[1]].forEach(function (y) {
              [a.min[2], a.max[2]].forEach(function (z) {
                var P = aplicar(m, [x, y, z]);
                for (var k = 0; k < 3; k++) {
                  min[k] = Math.min(min[k], P[k]);
                  max[k] = Math.max(max[k], P[k]);
                }
                radio = Math.max(radio, Math.hypot(P[0], P[2]));
              });
            });
          });
        });
        if (isFinite(min[1])) cajas.push({ min: min, max: max, yMin: min[1], yMax: max[1], radio: radio });
      }
      (n.children || []).forEach(function (c) { visitar(c, m, prof + 1); });
    }
    var escena = gltf.scenes && gltf.scenes[gltf.scene || 0];
    ((escena && escena.nodes) || []).forEach(function (r) { visitar(r, IDENTIDAD, 0); });
    return cajas;
  }

  /** Ventilador al revés: la pieza más ancha (las aspas) tiene su centro en la mitad alta. */
  function estaInvertido(cajas) {
    if (cajas.length < 2) return false;
    var yMin = Math.min.apply(null, cajas.map(function (c) { return c.yMin; }));
    var yMax = Math.max.apply(null, cajas.map(function (c) { return c.yMax; }));
    if (!(yMax > yMin)) return false;
    var aspas = cajas.reduce(function (a, b) { return b.radio > a.radio ? b : a; });
    return (aspas.yMin + aspas.yMax) / 2 > yMin + (yMax - yMin) / 2;
  }

  /** Caja total de todas las mallas. */
  function cajaTotal(cajas) {
    var min = [Infinity, Infinity, Infinity], max = [-Infinity, -Infinity, -Infinity];
    cajas.forEach(function (c) {
      for (var k = 0; k < 3; k++) {
        min[k] = Math.min(min[k], c.min[k]);
        max[k] = Math.max(max[k], c.max[k]);
      }
    });
    return { min: min, max: max };
  }

  /** ¿La cara `v` de un eje de largo `largo` pasa por el origen? (FARO pone ahí el anclaje.) */
  function enCero(v, largo) {
    return Math.abs(v) <= Math.max(0.003, 0.02 * largo);
  }

  /**
   * Giro para un aplique: model-viewer pega a la pared la cara trasera (-Z) de la caja. FARO exporta el anclaje en
   * Z=0 con la lámpara hacia +Z (ya vale) o en X=0 con la lámpara hacia -X (o +X): se gira sobre Y. Si la caja está
   * centrada no se sabe dónde está la pared y se deja como viene.
   */
  function giroPared(cajas) {
    if (!cajas.length) return null;
    var t = cajaTotal(cajas), min = t.min, max = t.max;
    var lx = max[0] - min[0], lz = max[2] - min[2];
    if (!(lx > 0) || !(lz > 0)) return null;
    if (enCero(min[2], lz) && !enCero(max[2], lz)) return null;
    if (enCero(max[0], lx) && !enCero(min[0], lx)) return GIRO_90_Y;
    if (enCero(min[0], lx) && !enCero(max[0], lx)) return GIRO_MENOS_90_Y;
    if (enCero(max[2], lz) && !enCero(min[2], lz)) return GIRO_180_Y;
    return null;
  }

  /**
   * Giro para una lámpara de techo (la RA la cuelga por la parte de arriba de su caja):
   * - colgando de Y=0 (plafones y colgantes de FARO): ya vale;
   * - anclaje en Z=0 (exportada «de pared», p. ej. empotrables y algunos plafones): +Z pasa a mirar al suelo;
   * - apoyada en Y=0 sobre una placa fina y centrada (un foco de techo exportado como de mesa): se da la vuelta.
   */
  function giroTecho(cajas) {
    if (!cajas.length) return null;
    var t = cajaTotal(cajas), min = t.min, max = t.max;
    var lx = max[0] - min[0], ly = max[1] - min[1], lz = max[2] - min[2];
    if (!(ly > 0)) return null;
    if (enCero(max[1], ly) && !enCero(min[1], ly)) return null;
    var suelo = enCero(min[1], ly) && !enCero(max[1], ly);
    if (!suelo && lz > 0 && (enCero(min[2], lz) !== enCero(max[2], lz))) return GIRO_90_X;
    if (suelo) {
      var ancho = Math.max(lx, lz);
      var placa = cajas.some(function (c) {
        var grueso = c.max[1] - c.min[1];
        var anchoC = Math.max(c.max[0] - c.min[0], c.max[2] - c.min[2]);
        var cx = (c.min[0] + c.max[0]) / 2, cz = (c.min[2] + c.max[2]) / 2;
        return enCero(c.min[1], ly) && grueso <= 0.02 && grueso <= 0.3 * anchoC &&
          Math.abs(cx) <= 0.25 * ancho && Math.abs(cz) <= 0.25 * ancho;
      });
      // Solo si esa placa de abajo es el florón: más ancha que lo que haya arriba. Un colgante que ya viene bien
      // (florón arriba, p. ej. DIANA: tapón de 3,4 cm abajo y florón de 8 cm arriba) no se da la vuelta.
      if (placa && anchoArriba(cajas, max[1], ly) < anchoAbajo(cajas, min[1], ly, ancho)) return GIRO_180_X;
    }
    return null;
  }

  /**
   * Ancho del florón arriba: la pieza fina (≤ 5 cm de grueso y como mucho la mitad de su ancho) y centrada más ancha que
   * toca la cara de arriba de la caja. El cuerpo de un foco que llega hasta arriba no cuenta (no es fino).
   */
  function anchoArriba(cajas, yMax, ly) {
    var mejor = 0;
    var t = cajaTotal(cajas);
    var ancho = Math.max(t.max[0] - t.min[0], t.max[2] - t.min[2]);
    cajas.forEach(function (c) {
      var grueso = c.max[1] - c.min[1];
      var anchoC = Math.max(c.max[0] - c.min[0], c.max[2] - c.min[2]);
      var cx = (c.min[0] + c.max[0]) / 2, cz = (c.min[2] + c.max[2]) / 2;
      if (Math.abs(c.max[1] - yMax) > Math.max(0.003, 0.02 * ly)) return;
      if (grueso <= 0.05 && grueso <= 0.5 * anchoC && Math.abs(cx) <= 0.25 * ancho && Math.abs(cz) <= 0.25 * ancho) mejor = Math.max(mejor, anchoC);
    });
    return mejor;
  }

  /** Ancho de la placa fina y centrada más ancha que toca la cara de abajo de la caja. */
  function anchoAbajo(cajas, yMin, ly, ancho) {
    var mejor = 0;
    cajas.forEach(function (c) {
      var grueso = c.max[1] - c.min[1];
      var anchoC = Math.max(c.max[0] - c.min[0], c.max[2] - c.min[2]);
      var cx = (c.min[0] + c.max[0]) / 2, cz = (c.min[2] + c.max[2]) / 2;
      if (Math.abs(c.min[1] - yMin) > Math.max(0.003, 0.02 * ly)) return;
      if (grueso <= 0.02 && grueso <= 0.3 * anchoC && Math.abs(cx) <= 0.25 * ancho && Math.abs(cz) <= 0.25 * ancho) mejor = Math.max(mejor, anchoC);
    });
    return mejor;
  }

  function leerGlb(buf) {
    var dv = new DataView(buf);
    if (dv.getUint32(0, true) !== GLTF) throw new Error('No es un .glb');
    var largoJson = dv.getUint32(12, true);
    if (dv.getUint32(16, true) !== JSON_CHUNK) throw new Error('El primer bloque no es JSON');
    var json = JSON.parse(new TextDecoder().decode(new Uint8Array(buf, 20, largoJson)));
    var bin = null;
    var off = 20 + largoJson;
    if (off + 8 <= buf.byteLength && dv.getUint32(off + 4, true) === BIN_CHUNK) {
      bin = new Uint8Array(buf, off + 8, dv.getUint32(off, true));
    }
    return { json: json, bin: bin };
  }

  function relleno4(n) { return (4 - (n % 4)) % 4; }

  function escribirGlb(json, bin) {
    var texto = new TextEncoder().encode(JSON.stringify(json));
    var lj = texto.length + relleno4(texto.length);
    var lb = bin ? bin.length + relleno4(bin.length) : 0;
    var total = 12 + 8 + lj + (bin ? 8 + lb : 0);
    var out = new Uint8Array(total);
    var dv = new DataView(out.buffer);
    dv.setUint32(0, GLTF, true);
    dv.setUint32(4, 2, true);
    dv.setUint32(8, total, true);
    dv.setUint32(12, lj, true);
    dv.setUint32(16, JSON_CHUNK, true);
    out.set(texto, 20);
    out.fill(0x20, 20 + texto.length, 20 + lj);
    if (bin) {
      dv.setUint32(20 + lj, lb, true);
      dv.setUint32(24 + lj, BIN_CHUNK, true);
      out.set(bin, 28 + lj);
    }
    return out;
  }

  /** Aro (radio exterior `radio`) y punto central en Y=altura, mirando hacia arriba. */
  function geometriaMarca(radio) {
    var interior = radio * 0.92, v = [], ind = [], i, a;
    for (i = 0; i < SEGMENTOS; i++) {
      a = (2 * Math.PI * i) / SEGMENTOS;
      v.push(radio * Math.cos(a), ALTURA_MARCA_M, radio * Math.sin(a), interior * Math.cos(a), ALTURA_MARCA_M, interior * Math.sin(a));
    }
    for (i = 0; i < SEGMENTOS; i++) {
      var o = 2 * i, n = 2 * ((i + 1) % SEGMENTOS);
      ind.push(o, o + 1, n, o + 1, n + 1, n);
    }
    var centro = v.length / 3;
    v.push(0, ALTURA_MARCA_M, 0);
    for (i = 0; i < SEGMENTOS; i++) {
      a = (2 * Math.PI * i) / SEGMENTOS;
      v.push(0.03 * Math.cos(a), ALTURA_MARCA_M, 0.03 * Math.sin(a));
    }
    for (i = 0; i < SEGMENTOS; i++) ind.push(centro, centro + 1 + i, centro + 1 + ((i + 1) % SEGMENTOS));
    var pos = new Float32Array(v), nor = new Float32Array(v.length);
    for (i = 1; i < nor.length; i += 3) nor[i] = 1;
    return { pos: pos, nor: nor, ind: new Uint16Array(ind) };
  }

  /**
   * Prepara un .glb de FARO. `colocacion`: 'pared' | 'techo' | 'suelo' (sin ella: 'techo' si `ventilador`, si no
   * 'suelo'). `ventilador`: gira si viene al revés. Pared y techo: se orienta (ver giroPared/giroTecho). `techo`
   * (solo con colocación techo): además lo cuelga a 2,5 m con el aro en el suelo (para la RA). Devuelve los bytes
   * nuevos (o los mismos si no hay nada que hacer).
   */
  function prepararGlb(buf, opciones) {
    opciones = opciones || {};
    var colocacion = opciones.colocacion || (opciones.ventilador ? 'techo' : 'suelo');
    if (!opciones.ventilador && colocacion !== 'pared' && colocacion !== 'techo') return new Uint8Array(buf);
    var g = leerGlb(buf), json = g.json, bin = g.bin;
    var escena = json.scenes && json.scenes[json.scene || 0];
    if (!escena || !escena.nodes || !escena.nodes.length) return new Uint8Array(buf);
    json.nodes = json.nodes || [];
    var giro = null;
    if (opciones.ventilador) giro = estaInvertido(cajasDeMallas(json)) ? GIRO_180_X : null;
    else if (colocacion === 'pared') giro = giroPared(cajasDeMallas(json));
    else giro = giroTecho(cajasDeMallas(json));
    if (giro) {
      escena.nodes = [json.nodes.push({ name: 'luzguru_orientacion', matrix: giro, children: escena.nodes.slice() }) - 1];
    } else if (colocacion === 'pared' || !opciones.techo) {
      return new Uint8Array(buf);
    }
    if (opciones.techo && colocacion === 'techo') {
      var cajas = cajasDeMallas(json);
      var yMin = Math.min.apply(null, cajas.map(function (c) { return c.yMin; }));
      var yMax = Math.max.apply(null, cajas.map(function (c) { return c.yMax; }));
      var radio = Math.max.apply(null, cajas.map(function (c) { return c.radio; }));
      var subida = ALTURA_TECHO_M - yMax;
      var buffers = (json.buffers = json.buffers || []);
      var binExterno = buffers.length && buffers[0].uri;
      var cabe = opciones.ventilador ? !estaInvertido(cajas) && yMin + subida >= HUECO_MINIMO_M : yMin + subida >= HUECO_LAMPARA_M;
      if (cajas.length && cabe && radio > 0 && !binExterno) {
        var m = geometriaMarca(radio);
        var antes = bin || new Uint8Array(0);
        var offPos = antes.length + relleno4(antes.length);
        var offNor = offPos + m.pos.byteLength;
        var offInd = offNor + m.nor.byteLength;
        var largo = offInd + m.ind.byteLength + relleno4(m.ind.byteLength);
        var nuevo = new Uint8Array(largo);
        nuevo.set(antes, 0);
        nuevo.set(new Uint8Array(m.pos.buffer), offPos);
        nuevo.set(new Uint8Array(m.nor.buffer), offNor);
        nuevo.set(new Uint8Array(m.ind.buffer), offInd);
        if (!buffers.length) buffers.push({ byteLength: 0 });
        buffers[0].byteLength = largo;
        var views = (json.bufferViews = json.bufferViews || []);
        var acc = (json.accessors = json.accessors || []);
        var nv = m.pos.length / 3;
        var vPos = views.push({ buffer: 0, byteOffset: offPos, byteLength: m.pos.byteLength, target: 34962 }) - 1;
        var vNor = views.push({ buffer: 0, byteOffset: offNor, byteLength: m.nor.byteLength, target: 34962 }) - 1;
        var vInd = views.push({ buffer: 0, byteOffset: offInd, byteLength: m.ind.byteLength, target: 34963 }) - 1;
        var aPos = acc.push({ bufferView: vPos, componentType: 5126, count: nv, type: 'VEC3', min: [-radio, ALTURA_MARCA_M, -radio], max: [radio, ALTURA_MARCA_M, radio] }) - 1;
        var aNor = acc.push({ bufferView: vNor, componentType: 5126, count: nv, type: 'VEC3' }) - 1;
        var aInd = acc.push({ bufferView: vInd, componentType: 5123, count: m.ind.length, type: 'SCALAR' }) - 1;
        var mat = (json.materials = json.materials || []).push({
          name: 'luzguru_marca_suelo',
          pbrMetallicRoughness: { baseColorFactor: [0.72, 0.55, 0.25, 1], metallicFactor: 0, roughnessFactor: 1 },
          doubleSided: true
        }) - 1;
        var malla = (json.meshes = json.meshes || []).push({ name: 'luzguru_marca_suelo', primitives: [{ attributes: { POSITION: aPos, NORMAL: aNor }, indices: aInd, material: mat }] }) - 1;
        var r = json.nodes.push({ name: 'luzguru_altura_techo', translation: [0, subida, 0], children: escena.nodes.slice() }) - 1;
        var marca = json.nodes.push({ name: 'luzguru_marca_suelo', mesh: malla }) - 1;
        escena.nodes = [r, marca];
        bin = nuevo;
      }
    }
    return escribirGlb(json, bin);
  }

  // ─────────────── .usdz (iPhone): anclaje vertical para los apliques ───────────────

  var TABLA_CRC = null;
  function crc32(bytes, desde, hasta) {
    if (!TABLA_CRC) {
      TABLA_CRC = new Uint32Array(256);
      for (var n = 0; n < 256; n++) {
        var c = n;
        for (var k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        TABLA_CRC[n] = c >>> 0;
      }
    }
    var crc = 0xffffffff;
    for (var i = desde; i < hasta; i++) crc = TABLA_CRC[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
    return (crc ^ 0xffffffff) >>> 0;
  }

  function buscar(bytes, aguja, desde, hasta) {
    outer: for (var i = desde; i <= hasta - aguja.length; i++) {
      for (var j = 0; j < aguja.length; j++) if (bytes[i + j] !== aguja[j]) continue outer;
      return i;
    }
    return -1;
  }

  /**
   * model-viewer 4.0.0 genera el .usdz con `preliminary:planeAnchoring:alignment = "horizontal"` siempre. Para la
   * pared se cambia por "vertical" con el mismo número de bytes (relleno con espacios, válido en .usda), y se
   * recalcula el CRC del fichero en el zip (sin comprimir, como lo escribe model-viewer). Devuelve null si no lo
   * encuentra o el zip no es como se espera (entonces se usa el original: el aplique sale en el suelo).
   */
  function usdzVertical(bytes) {
    var ancla = new TextEncoder().encode('planeAnchoring:alignment = "horizontal"');
    var nuevo = new TextEncoder().encode('planeAnchoring:alignment = "vertical"  ');
    var dv = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    var off = 0, hecho = false;
    // Ficheros locales: firma, método (0 = sin comprimir), tamaños, nombre y datos.
    while (off + 30 <= bytes.length && dv.getUint32(off, true) === 0x04034b50) {
      var flags = dv.getUint16(off + 6, true);
      var metodo = dv.getUint16(off + 8, true);
      var tam = dv.getUint32(off + 18, true);
      var ln = dv.getUint16(off + 26, true), le = dv.getUint16(off + 28, true);
      var datos = off + 30 + ln + le;
      if (flags & 8 || datos + tam > bytes.length) return null;
      var nombre = new TextDecoder().decode(bytes.subarray(off + 30, off + 30 + ln));
      if (!hecho && metodo === 0 && /\.usda$/.test(nombre)) {
        var pos = buscar(bytes, ancla, datos, datos + tam);
        if (pos >= 0) {
          bytes.set(nuevo, pos);
          var crc = crc32(bytes, datos, datos + tam);
          dv.setUint32(off + 14, crc, true);
          // Y el mismo CRC en el directorio central.
          var cd = buscar(bytes, new Uint8Array([0x50, 0x4b, 0x01, 0x02]), datos + tam, bytes.length);
          while (cd >= 0 && cd + 46 <= bytes.length) {
            var lnc = dv.getUint16(cd + 28, true);
            var nc = new TextDecoder().decode(bytes.subarray(cd + 46, cd + 46 + lnc));
            if (nc === nombre) {
              dv.setUint32(cd + 16, crc, true);
              hecho = true;
              break;
            }
            cd += 46 + lnc + dv.getUint16(cd + 30, true) + dv.getUint16(cd + 32, true);
            if (dv.getUint32(cd, true) !== 0x02014b50) break;
          }
          if (!hecho) return null;
        }
      }
      off = datos + tam;
    }
    return hecho ? bytes : null;
  }

  var api = {
    prepararGlb: prepararGlb,
    cajasDeMallas: cajasDeMallas,
    estaInvertido: estaInvertido,
    leerGlb: leerGlb,
    giroPared: giroPared,
    giroTecho: giroTecho,
    usdzVertical: usdzVertical
  };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }
  raiz.LgFaro3d = api;
  api.cargarModelViewer = function () { return cargarModelViewer(); };
  api.blobDe = function (url, opciones) { return blobDe(url, opciones); };

  // ─────────────── Página: visor, variantes y «Ver en tu espacio» ───────────────

  var cargaVisor = null;
  function cargarModelViewer() {
    if (window.customElements && customElements.get('model-viewer')) return Promise.resolve();
    if (cargaVisor) return cargaVisor;
    cargaVisor = new Promise(function (ok, mal) {
      var s = document.createElement('script');
      s.type = 'module';
      s.src = MODEL_VIEWER_URL;
      s.onload = function () { customElements.whenDefined('model-viewer').then(ok); };
      s.onerror = mal;
      document.head.appendChild(s);
    });
    return cargaVisor;
  }

  var cache = {};
  function blobDe(url, opciones) {
    var clave = url + '|' + (opciones.ventilador ? 'v' : '') + (opciones.techo ? 't' : '') + '|' + (opciones.colocacion || '');
    if (!cache[clave]) {
      cache[clave] = fetch(url, { mode: 'cors' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.arrayBuffer();
        })
        .then(function (buf) {
          return URL.createObjectURL(new Blob([prepararGlb(buf, opciones)], { type: 'model/gltf-binary' }));
        });
      cache[clave].catch(function () { delete cache[clave]; });
    }
    return cache[clave];
  }

  function esperarCarga(mv) {
    return new Promise(function (ok, mal) {
      function listo() { quitar(); ok(); }
      function fallo(e) { quitar(); mal(e); }
      function quitar() { mv.removeEventListener('load', listo); mv.removeEventListener('error', fallo); }
      mv.addEventListener('load', listo);
      mv.addEventListener('error', fallo);
    });
  }

  // Modelo vigente de cada sección (cambia con la variante): lo lee «Pruébalo en tu techo».
  var modelos = {};

  function iniciar(caja) {
    if (caja.dataset.lg3dListo) return;
    caja.dataset.lg3dListo = '1';
    var ventilador = caja.dataset.ventilador === 'true';
    var colocacion = caja.dataset.colocacion || (ventilador ? 'techo' : 'suelo');
    var mapa = {};
    try { mapa = JSON.parse((caja.querySelector('[data-lg3d-variantes]') || {}).textContent || '{}'); } catch (e) { mapa = {}; }
    var estado = { glb: caja.dataset.glb, glbDef: caja.dataset.glb, mv: null };
    var lienzo = caja.querySelector('[data-lg3d-lienzo]');
    var abrir = caja.querySelector('[data-lg3d-abrir]');
    var seccion = caja.dataset.seccion;
    var boton = document.querySelector('[data-lg3d-ar][data-seccion="' + seccion + '"]');
    var aviso = boton && boton.parentElement.querySelector('[data-lg3d-aviso]');
    modelos[seccion] = function () {
      return { glb: estado.glb, ventilador: ventilador, titulo: caja.dataset.titulo || '' };
    };

    // Cada variante enseña SOLO su modelo (decisión de Álvaro, 2026-10-12): si la ficha tiene modelos por variante y la
    // elegida no tiene el suyo (p. ej. otra medida sin .glb en FARO), se ocultan su diapositiva 3D, su miniatura y
    // «Ver en tu espacio» en vez de enseñar el modelo de otra variante. Fichas sin modelos por variante: como siempre.
    var porVariante = Object.keys(mapa).length > 0;
    function verModeloDe(idVariante) {
      var sinModelo = porVariante && !!idVariante && !mapa[String(idVariante)];
      // Tras Dawn y lg-media-variante, que rehacen diapositivas y miniaturas al cambiar de variante.
      setTimeout(function () {
        var li = document.getElementById('Slide-' + seccion + '-lg3d');
        var mini = document.getElementById('Slide-Thumbnails-' + seccion + '-lg3d');
        [li, mini].forEach(function (el) {
          if (!el) return;
          el.hidden = sinModelo;
          el.style.display = sinModelo ? 'none' : '';
        });
        if (boton) boton.style.display = sinModelo ? 'none' : '';
      }, 0);
      return !sinModelo;
    }
    verModeloDe(caja.dataset.varianteInicial);

    function crearVisor() {
      if (estado.mv) return Promise.resolve(estado.mv);
      return cargarModelViewer().then(function () {
        var mv = document.createElement('model-viewer');
        mv.setAttribute('alt', 'Modelo 3D interactivo y realidad aumentada de ' + (caja.dataset.titulo || 'producto'));
        mv.setAttribute('camera-controls', '');
        mv.setAttribute('touch-action', 'pan-y');
        mv.setAttribute('shadow-intensity', '1');
        mv.setAttribute('ar', '');
        mv.setAttribute('ar-modes', 'webxr quick-look');
        mv.setAttribute('ar-scale', 'fixed');
        // Sin esto model-viewer no carga el modelo hasta que su diapositiva entra en pantalla, y «Ver en tu espacio» se
        // quedaba esperando a que el cliente deslizara hasta la imagen 3D.
        mv.setAttribute('loading', 'eager');
        mv.setAttribute('reveal', 'auto');
        if (colocacion === 'pared') {
          mv.setAttribute('ar-placement', 'wall');
          // Quick Look: el .usdz que genera model-viewer siempre va al suelo; se ancla a la pared.
          var usdzOriginal = mv.prepareUSDZ;
          if (typeof usdzOriginal === 'function') {
            mv.prepareUSDZ = function () {
              return usdzOriginal.call(mv).then(function (url) {
                if (!url) return url;
                return fetch(url)
                  .then(function (r) { return r.arrayBuffer(); })
                  .then(function (buf) {
                    var b = usdzVertical(new Uint8Array(buf));
                    if (!b) return url;
                    URL.revokeObjectURL(url);
                    return URL.createObjectURL(new Blob([b], { type: 'model/vnd.usdz+zip' }));
                  })
                  .catch(function () { return url; });
              });
            };
          }
        }
        mv.setAttribute('alt', caja.dataset.titulo || 'Modelo 3D');
        mv.className = 'lg-3d__visor';
        lienzo.appendChild(mv);
        estado.mv = mv;
        // Al salir de la RA vuelve el modelo normal (sin colgar del techo).
        mv.addEventListener('ar-status', function (e) {
          if (e.detail && e.detail.status === 'not-presenting' && caja.dataset.enRa) {
            delete caja.dataset.enRa;
            mostrar(false);
          }
        });
        return mv;
      });
    }

    function mostrar(techo) {
      return crearVisor().then(function (mv) {
        return blobDe(estado.glb, { ventilador: ventilador, colocacion: colocacion, techo: !!techo && colocacion === 'techo' }).then(function (src) {
          if (mv.src === src) return mv;
          var carga = esperarCarga(mv);
          mv.src = src;
          return carga.then(function () {
            caja.classList.add('is-cargado');
            return mv;
          });
        });
      });
    }

    if (abrir) {
      abrir.addEventListener('click', function () {
        if (window.pauseAllMedia) window.pauseAllMedia();
        caja.classList.add('is-cargando');
        mostrar(false)
          .catch(function () { caja.classList.add('is-error'); })
          .then(function () { caja.classList.remove('is-cargando'); });
      });
    }

    // Lleva la galeria a la diapositiva 3D (el cliente ve que el modelo se esta cargando y model-viewer lo carga ya):
    // con la funcion de la galeria de Dawn (tambien marca la miniatura) o, si no esta, desplazando la tira.
    function irAlSlide() {
      var galeria = document.getElementById('MediaGallery-' + seccion);
      if (galeria && typeof galeria.setActiveMedia === 'function') {
        try { galeria.setActiveMedia(seccion + '-lg3d', false); return; } catch (e) {}
      }
      var li = document.getElementById('Slide-' + seccion + '-lg3d');
      if (li && li.parentElement && li.parentElement.scrollWidth > li.parentElement.clientWidth) {
        li.parentElement.scrollTo({ left: li.offsetLeft });
      }
    }

    // Precarga: en cuanto «Ver en tu espacio» asoma en pantalla (solo se ve en movil) se descargan el visor y el modelo de
    // la RA, para que al pulsar se abra al momento (el movil solo deja abrir la RA unos segundos despues del toque).
    function precargar() {
      cargarModelViewer().catch(function () {});
      blobDe(estado.glb, { ventilador: ventilador, colocacion: colocacion, techo: colocacion === 'techo' }).catch(function () {});
    }
    if (boton && 'IntersectionObserver' in window) {
      var vigia = new IntersectionObserver(function (entradas) {
        if (!entradas.some(function (e) { return e.isIntersecting && boton.offsetParent !== null; })) return;
        vigia.disconnect();
        precargar();
      }, { rootMargin: '200px' });
      vigia.observe(boton);
    }

    if (boton) {
      boton.addEventListener('click', function () {
        boton.setAttribute('aria-busy', 'true');
        irAlSlide();
        if (aviso) aviso.hidden = true;
        mostrar(true)
          .then(function (mv) {
            if (!mv.canActivateAR) {
              if (aviso) aviso.hidden = false;
              return mostrar(false);
            }
            caja.dataset.enRa = '1';
            return mv.activateAR();
          })
          .catch(function () { if (aviso) aviso.hidden = false; })
          .then(function () { boton.removeAttribute('aria-busy'); });
      });
    }

    function enlazarVariantes(intento) {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var v = event && event.data && event.data.variant;
          if (!v) return;
          if (!verModeloDe(v.id)) return;
          var nuevo = mapa[String(v.id)] || estado.glbDef;
          if (nuevo === estado.glb) return;
          estado.glb = nuevo;
          if (estado.mv) {
            estado.mv.setAttribute('alt', 'Modelo 3D interactivo y realidad aumentada de ' + (v.name || caja.dataset.titulo || 'producto'));
          }
          document.dispatchEvent(new CustomEvent('lg3d:variante', { detail: { seccion: seccion, glb: nuevo } }));
          if (estado.mv && estado.mv.src && !caja.dataset.enRa) mostrar(false).catch(function () {});
        });
      } else if ((intento || 0) < 50) {
        setTimeout(function () { enlazarVariantes((intento || 0) + 1); }, 100);
      }
    }
    if (Object.keys(mapa).length) enlazarVariantes(0);
  }

  // ─────────────── «Pruébalo en tu techo»: carga perezosa ───────────────

  var cargaTecho = null;
  function cargarTecho(boton) {
    if (window.LgTecho) return Promise.resolve(window.LgTecho);
    if (cargaTecho) return cargaTecho;
    cargaTecho = new Promise(function (ok, mal) {
      if (boton.dataset.lgTechoCss) {
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = boton.dataset.lgTechoCss;
        document.head.appendChild(l);
      }
      var s = document.createElement('script');
      s.src = boton.dataset.lgTechoJs;
      s.onload = function () { window.LgTecho ? ok(window.LgTecho) : mal(new Error('LgTecho')); };
      s.onerror = mal;
      document.head.appendChild(s);
    });
    cargaTecho.catch(function () { cargaTecho = null; });
    return cargaTecho;
  }

  function enlazarTecho(boton) {
    boton.addEventListener('click', function () {
      var modelo = modelos[boton.dataset.seccion];
      if (!modelo || boton.getAttribute('aria-busy') === 'true') return;
      if (window.pauseAllMedia) window.pauseAllMedia();
      boton.setAttribute('aria-busy', 'true');
      cargarTecho(boton)
        .then(function (techo) { techo.abrir({ seccion: boton.dataset.seccion, modelo: modelo, origen: boton }); })
        .catch(function () {})
        .then(function () { boton.removeAttribute('aria-busy'); });
    });
  }

  function arrancar() {
    document.querySelectorAll('[data-lg3d]').forEach(iniciar);
    document.querySelectorAll('[data-lg-techo]').forEach(enlazarTecho);
    var ua = navigator.userAgent || '';
    var movil = /Android|iPad|iPhone|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var ios = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    document.querySelectorAll('[data-lg3d-ar]').forEach(function (b) {
      var caja = b.closest('[data-lg3d-ar-caja]');
      if (!movil) return;
      caja.hidden = false;
      b.hidden = false;
      var pista = caja.querySelector('[data-lg-ar-ios-hint]');
      if (pista && ios) pista.hidden = false;
      var pistaMovil = caja.querySelector('[data-lg-ar-movil-hint]');
      if (pistaMovil) pistaMovil.hidden = false;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})(typeof window !== 'undefined' ? window : this);
